import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { DashboardDataResponse, DashboardMostItemRequested } from "@/types/interface/dashboard";
import { ref } from "vue";
import { db } from "@/database/db";

const loginInfo = ref();
const stringLoginInfo = await db.storage.get("login-info")!;
loginInfo.value = stringLoginInfo?.data;

async function dashboardGeneral() {
  return await http.get<APIResponse<DashboardDataResponse>>(`dashboard-general`);
}

async function dashboardGetItemByCategory() {
  let queryParam = "";
  if (loginInfo?.value?.job?.id != undefined){
    queryParam = '?job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<DashboardDataResponse>>(`dashboard-general-item-by-category${queryParam}`);
}

async function dashboardGetItemByGroupCategory(query: string) {
  if (loginInfo?.value?.job?.id != undefined){
    query = query + '&job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<DashboardDataResponse>>(`dashboard-general-item-by-group-category${query}`);
}

async function dashboardRequisitionOverview(query: string) {
  if (loginInfo?.value?.job?.id != undefined){
    query = query + '?job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<DashboardDataResponse>>(`dashboard-general-requisition-overview${query}`);
}

async function dashboardMostItemRequested(query: string) {
  if (loginInfo?.value?.job?.id != undefined){
    query = query + '?job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<DashboardMostItemRequested>>(`dashboard-general-most-requested-item${query}`);
}

export default {
  dashboardGeneral,
  dashboardGetItemByCategory,
  dashboardGetItemByGroupCategory,
  dashboardRequisitionOverview,
  dashboardMostItemRequested
};